<header class="main-header">
    <!-- Logo -->
    <a *ngIf="rendererService.config.menu" routerLink='' class="logo" [ngStyle]="{'background-color': rendererService.config.color}">
        <!-- mini logo for sidebar mini 50x50 pixels -->
        <span class="logo-mini" ><img style="margin-left: 5px; margin-bottom: 3px" src="{{ rendererService.config.logoMini }}" alt="Small logo"></span>
        <!-- logo for regular state and mobile devices -->
        <span class="logo-lg"><img style="margin-bottom: 3px" src="{{ rendererService.config.logoLarge }}" alt="Large logo"></span>
    </a>
    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top" [ngStyle]="{'background-color': rendererService.currentConfig === GlobalConf.Apps.CAPA && !rendererService.config.menu ? rendererService.config.color : '#222d32' }">
        <!-- Sidebar toggle button-->
        <a href="#" *ngIf="rendererService.config.menu" class="sidebar-toggle" data-toggle="push-menu" role="button">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
        </a>

        <a *ngIf="hasCapaUser() && rendererService.currentConfig === GlobalConf.Apps.CAPA" href="capa" class="navbar-brand" style="padding-top: 2px; border-right: none;">
            <img src="assets/images/CAPA_Icon_48x140.png" alt="">
        </a>

        <div class="navbar-custom-menu">
            <ul class="nav navbar-nav">
                <!-- Tasks: style can be found in dropdown.less -->
                <li class="dropdown language-menu" *ngIf="rendererService.currentConfig !== GlobalConf.Apps.CAPA">
                    <a href="" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            {{CurrentUser?.lang | uppercase}}
          </a>
                    <ul class="dropdown-menu">
                        <li class="header" i18n="@@ChooseYourLanguage">Choose your language</li>
                        <li>
                            <!-- inner menu: contains the actual data -->
                            <ul class="menu">
                                <li *ngFor="let lang of supportedLanguages">
                                    <!-- start message -->
                                    <a (click)="selectLangByMenu(lang.value)">
                                        <h5>{{lang.display}}</h5>
                                    </a>
                                </li>
                                <!-- end message -->
                            </ul>
                        </li>
                    </ul>
                </li>
                <!-- User Account: style can be found in dropdown.less -->
                <li *ngIf="CurrentUser && !hasCapaUser()" class="dropdown user user-menu">
                    <a class="dropdown-toggle" data-toggle="dropdown">
                        <img *ngIf="userPhoto" [src]="userPhoto" class="user-image" alt="User Image">
                        <span class="hidden-xs">{{CurrentUser?.name}}</span>
                    </a>
                </li>
                <!-- Control Sidebar Toggle Button -->
                <li *ngIf="rendererService.config.menu">
                    <a href="#" (click)="logout()"><em class="fa fa-power-off"></em></a>
                </li>

                <li *ngIf="rendererService.currentConfig === GlobalConf.Apps.CAPA && hasCapaUser() && router.url === '/capa/result/list/account'">
                    <a href="" data-toggle="control-sidebar"><span  i18n="@@myAccount">My account</span><em class="fa fa-user" style="margin-left: 10px"></em></a>
                </li>
            </ul>
        </div>
    </nav>
</header>
